module.exports = new __parcel__URL__("clock-with-exclamation-mark.db9b1ed9.svg").toString();